import { CmsOffer } from '../../../types/cmsProduct';

const getMaxGiftPrice = (offers: CmsOffer[]): number => {
  let max = 0;
  for (const offer of offers) {
    for (const gift of offer.list_of_gifts ?? []) {
      const price = gift.gift?.gift_value?.price ?? 0;
      if (price > max) {
        max = price;
      }
    }
  }
  return max;
};

export const computeTotalMaxValue = (
  exclusiveOffers: CmsOffer[],
  welcomeOffers: CmsOffer[],
): { totalMaxValue: number; maxValueSS: number; maxValueProvider: number } => {
  const maxValueSS = getMaxGiftPrice(exclusiveOffers);
  const maxValueProvider = getMaxGiftPrice(welcomeOffers);
  return {
    totalMaxValue: maxValueSS + maxValueProvider,
    maxValueSS,
    maxValueProvider,
  };
};

export const getCurrencyPrefix = (offers: CmsOffer[]): string | undefined => {
  for (const offer of offers) {
    for (const gift of offer.list_of_gifts ?? []) {
      if (gift.gift?.gift_value?.prefix) {
        return gift.gift.gift_value.prefix;
      }
    }
  }
  return undefined;
};
